const API_URL = 'https://api.erpsaude.com.br/console/api/clientes/cnes';
const API_KEY = 'aLFZwFXXRvYTWUEWglioIDcjSajhkxql';
const CACHE_KEY = 'erpSaudeClientesCnesAuthCache';
const CACHE_TTL_MS = 6 * 60 * 60 * 1000;

function slugifyHospitalName(name) {
  if (!name || name === '-') {
    return null;
  }

  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function buildAuthenticationMap(clients) {
  return clients.reduce((authentication, client) => {
    if (!client || client.ativo === false || !client.auth) {
      return authentication;
    }

    const cnes = String(client.cnes || '').trim();
    const hospitalSlug = slugifyHospitalName(client.nome);

    if (cnes) {
      authentication[cnes] = client.auth;
    }

    if (hospitalSlug) {
      authentication[hospitalSlug] = client.auth;
    }

    return authentication;
  }, {});
}

function readCache() {
  try {
    const rawCache = window.localStorage.getItem(CACHE_KEY);

    if (!rawCache) {
      return null;
    }

    const parsedCache = JSON.parse(rawCache);

    if (!parsedCache?.expiresAt || !parsedCache?.authentication) {
      return null;
    }

    if (parsedCache.expiresAt < Date.now()) {
      window.localStorage.removeItem(CACHE_KEY);
      return null;
    }

    return parsedCache.authentication;
  } catch (error) {
    return null;
  }
}

function writeCache(authentication) {
  try {
    window.localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        authentication,
        expiresAt: Date.now() + CACHE_TTL_MS,
      }),
    );
  } catch (error) {
    // Ignora falhas de storage e segue usando os dados apenas em memória.
  }
}

async function fetchAuthenticationMap() {
  const response = await fetch(API_URL, {
    headers: {
      'x-api-key': API_KEY,
    },
  });

  if (!response.ok) {
    throw new Error(`Falha ao consultar clientes: ${response.status}`);
  }

  const clients = await response.json();

  if (!Array.isArray(clients)) {
    throw new Error('Resposta inválida da API de clientes.');
  }

  const authentication = buildAuthenticationMap(clients);
  writeCache(authentication);

  return authentication;
}

export async function getAuthenticationMap({ forceRefresh = false } = {}) {
  if (!forceRefresh) {
    const cachedAuthentication = readCache();

    if (cachedAuthentication) {
      return cachedAuthentication;
    }
  }

  return fetchAuthenticationMap();
}

export async function getHospitalToken(hospital) {
  if (!hospital) {
    return null;
  }

  const cachedAuthentication = readCache();

  if (cachedAuthentication?.[hospital]) {
    return cachedAuthentication[hospital];
  }

  const authentication = await getAuthenticationMap({
    forceRefresh: Boolean(cachedAuthentication),
  });

  return authentication[hospital] || null;
}

export async function refreshAuthenticationMap() {
  return fetchAuthenticationMap();
}
